<style scoped lang="scss" type="text/scss">
.file-info-container {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .file-type-container {
    display: flex;
    justify-content: center;

    .file-type {
      font-size: 3.5rem;
    }
  }

  .file-name {
    line-height: 1rem;
    margin-top: 1rem;
    font-size: 0.85rem;
    color: #666;
    text-align: center;
  }

  .file-size {
    line-height: 1rem;
    margin-top: 0.5rem;
    font-size: 0.75rem;
    color: #999;
    text-align: center;
  }
}
</style>

<template>
  <div class="file-info-container">
    <div class="file-type-container">
      <svg class="c-icon file-type" aria-hidden="true">
        <use :xlink:href="'#' + fileTypeIcon"></use>
      </svg>
    </div>
    <span class="file-name global-text-ellipsis">
      {{ fileName }}
    </span>
    <span class="file-size global-text-ellipsis">
      {{ formattedFileSize }}
    </span>
  </div>
</template>

<script>
import formatFileSize from "../../utils/file/format-filesize";

export default {
  name: "",
  props: {
    fileName: {
      type: String,
      default: "",
    },
    fileType: {
      type: String,
      default: "",
    },
    fileSize: {
      type: Number,
      default: 0,
    },
    fileExtensionName: {
      type: String,
      default: "new",
    },
  },
  computed: {
    fileTypeIcon() {
      let icon = null;
      // console.log("111", this.fileType);
      const value = (icon = this.iconMapper[this.fileType]);
      if (undefined === value) {
        icon = "icon-NEW";
      }
      return icon;
    },
    formattedFileSize() {
      return formatFileSize(this.fileSize);
    },
  },
  data() {
    return {
      iconMapper: {
        ".png": "icon-NEW",
        ".jpeg": "icon-NEW",
        ".jpg": "icon-NEW",
        ".svg": "icon-NEW",
        ".gif": "icon-NEW",
        ".pdf": "icon-PDF",
        ".doc": "icon-DOC",
        ".docx": "icon-DOC",
        ".ppt": "icon-PPT",
        ".pptx": "icon-PPT",
        ".xls": "icon-XLS",
        ".xlsx": "icon-XLS",
        ".mp4": "icon-shipin",
      },
    };
  },
};
</script>
